import { splitLines } from './splitLines';

export const initTitle = () => {
  let title = document.querySelectorAll('.js-title');

  if (!title) {
    return false
  }

  title.forEach(title => {
    splitLines(title, '<span>', '<div class="line"></div></span>');
  });

  let lines = document.querySelectorAll('.line');

  lines.forEach((item, index) => {
    setTimeout(() => {
      item.classList.add('active');
    }, index === 0 ? 0 : index * 2000);
  });
};
